import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import App from './app';
import * as serviceWorker from './serviceWorker';
import './i18n/index'; // 初始化i18n

ReactDOM.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#0196FE',
      },
    }}
  >
    <App />
  </ConfigProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
